(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("learningItemTranslationsService", ["$http", learningItemTranslationsService]);
    function learningItemTranslationsService($http) {
        var learningItemServiceFactory = {};
        var exportSelectedToCsv = function (learningItemCodes, languageCulture) {
            var data = { learningItemCodes: learningItemCodes, languageCulture: languageCulture };
            return $http({ method: 'POST', url: 'api/learningItemLocalizations', data: data });
        };
        var exportNeedsTranslationToCsv = function (languageCulture) {
            return $http({ method: 'POST', url: 'api/learningItemLocalizations/exportNeedsTranslationToCsv/' + languageCulture });
        };
        var updateLearningItemLocalizations = function (data) {
            return $http({ method: 'POST', url: 'api/learningItemLocalizations/batchUpdate', data: JSON.stringify(data) });
        };
        learningItemServiceFactory.exportSelectedToCsv = exportSelectedToCsv;
        learningItemServiceFactory.exportNeedsTranslationToCsv = exportNeedsTranslationToCsv;
        learningItemServiceFactory.updateLearningItemLocalizations = updateLearningItemLocalizations;
        return learningItemServiceFactory;
    }
}());
